export default function SeniorAppSection() {
  return (
    <section id="elderly-dashboard" className="bg-white py-16 md:py-24 px-4 md:px-8 lg:px-12">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <div className="flex justify-center order-2 lg:order-1">
            <div className="relative">
              <div className="w-[280px] md:w-[320px] bg-primary-500 rounded-[3rem] p-3 shadow-2xl shadow-primary-500/20">
                <div className="bg-white rounded-[2.5rem] overflow-hidden">
                  <div className="bg-primary-500 h-6 flex items-center justify-center rounded-t-[2.5rem]">
                    <div className="w-16 h-1 bg-white/30 rounded-full"></div>
                  </div>
                  <div className="p-5 pb-8">
                    <div className="text-center mb-5">
                      <div className="w-8 h-8 mx-auto bg-accent-500/10 rounded-lg flex items-center justify-center mb-2">
                        <i className="ri-heart-pulse-line text-accent-500 text-sm"></i>
                      </div>
                      <h4 className="text-sm font-semibold text-foreground-950">Good Morning, Mom</h4>
                      <p className="text-xs text-foreground-600/50">Today is Wednesday, August 24</p>
                    </div>
                    <div className="space-y-3">
                      <div className="flex items-center gap-3 bg-primary-500/10 rounded-xl p-3">
                        <div className="w-10 h-10 flex items-center justify-center bg-primary-500 rounded-xl shrink-0">
                          <i className="ri-medicine-bottle-line text-white text-lg"></i>
                        </div>
                        <div className="flex-1">
                          <p className="text-sm font-semibold text-foreground-950">Medications</p>
                          <p className="text-xs text-foreground-600/50">3 today</p>
                        </div>
                        <div className="w-6 h-6 bg-secondary-500 rounded-full flex items-center justify-center">
                          <i className="ri-check-line text-white text-xs"></i>
                        </div>
                      </div>
                      <div className="flex items-center gap-3 bg-secondary-500/10 rounded-xl p-3">
                        <div className="w-10 h-10 flex items-center justify-center bg-secondary-500 rounded-xl shrink-0">
                          <i className="ri-restaurant-line text-white text-lg"></i>
                        </div>
                        <div className="flex-1">
                          <p className="text-sm font-semibold text-foreground-950">Meals</p>
                          <p className="text-xs text-foreground-600/50">Breakfast logged</p>
                        </div>
                        <div className="w-6 h-6 bg-secondary-500 rounded-full flex items-center justify-center">
                          <i className="ri-check-line text-white text-xs"></i>
                        </div>
                      </div>
                      <div className="flex items-center gap-3 bg-accent-500/10 rounded-xl p-3">
                        <div className="w-10 h-10 flex items-center justify-center bg-accent-500 rounded-xl shrink-0">
                          <i className="ri-stethoscope-line text-white text-lg"></i>
                        </div>
                        <div className="flex-1">
                          <p className="text-sm font-semibold text-foreground-950">Doctor Visits</p>
                          <p className="text-xs text-foreground-600/50">Tomorrow 10:00 AM</p>
                        </div>
                      </div>
                      <div className="flex items-center gap-3 bg-primary-400/10 rounded-xl p-3">
                        <div className="w-10 h-10 flex items-center justify-center bg-primary-400 rounded-xl shrink-0">
                          <i className="ri-group-line text-white text-lg"></i>
                        </div>
                        <div className="flex-1">
                          <p className="text-sm font-semibold text-foreground-950">Family Visits</p>
                          <p className="text-xs text-foreground-600/50">Sarah coming Saturday</p>
                        </div>
                      </div>
                      <div className="mt-4 pt-3 border-t border-background-200/70">
                        <div className="flex items-center gap-3 bg-accent-400/10 rounded-xl p-3 border-2 border-accent-400/20">
                          <div className="w-10 h-10 flex items-center justify-center bg-accent-400 rounded-xl shrink-0">
                            <i className="ri-alarm-warning-line text-white text-lg"></i>
                          </div>
                          <div className="flex-1">
                            <p className="text-sm font-semibold text-accent-500">Emergency SOS</p>
                            <p className="text-xs text-foreground-600/50">Press and hold for help</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="h-1 w-24 bg-white/30 rounded-full mx-auto mt-2"></div>
              </div>
            </div>
          </div>
          <div className="order-1 lg:order-2">
            <div className="inline-flex items-center gap-2 bg-secondary-500/10 rounded-full px-3 py-1.5 mb-5">
              <i className="ri-smartphone-line text-secondary-500 text-xs"></i>
              <span className="text-xs font-semibold text-secondary-500 uppercase tracking-wider">For Seniors</span>
            </div>
            <h2 className="font-heading text-3xl md:text-4xl text-foreground-950 mb-5 leading-tight">
              Built to be simple for elderly users
            </h2>
            <p className="text-base text-foreground-600/80 leading-relaxed mb-8">
              The elderly parent dashboard is designed with large buttons, clear text, and simple actions. No confusing menus, no tiny text, no overwhelming screens.
            </p>
            <div className="space-y-3">
              {[
                'Large easy-to-read buttons',
                'Simple daily schedule',
                'Medication taken / missed button',
                'One-touch emergency SOS',
                'High contrast mode',
                'Voice-friendly navigation',
                'Minimal clutter',
              ].map((item, idx) => (
                <div key={idx} className="flex items-center gap-3">
                  <div className="w-5 h-5 flex items-center justify-center bg-secondary-500/10 rounded-full shrink-0">
                    <i className="ri-check-line text-secondary-500 text-xs"></i>
                  </div>
                  <span className="text-sm text-foreground-700/80">{item}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}